{% block sw_category_upselling_form %}
    <div class="category-detail-upselling-form">
        <sw-card :title="displayTitle" :isLoading="isLoading">
            {% block sw_prduct_upselling_form_context_menu %}
                <div class="sw-category-detail-upselling__context-button">
                    <sw-context-button>
                        {% block sw_category_upselling_form_context_button_delete %}
                            <sw-context-menu-item
                                    variant="danger"
                                    class="sw-category-upselling-context-item__delete-action"
                                    @click="onShowDeleteModal">
                                {{ $tc('sw-category.upselling.buttonDeleteUpselling') }}
                            </sw-context-menu-item>
                        {% endblock %}
                    </sw-context-button>
                </div>
            {% endblock %}
            <sw-container columns="2fr 1fr" gap="0px 30px">
                {% block sw_category_upselling_form_title_field %}
                    <mt-text-field
                            v-model="upselling.name"
                            name="'upselling--name-'+upselling.id"
                            :label="$tc('sw-category.upselling.inputUpsellingTitle')"
                            required
                            :placeholder="$tc('sw-category.upselling.inputUpsellingTitlePlaceholder')"
                    ></mt-text-field>
                {% endblock %}

                {% block sw_category_upselling_form_active_field %}
                    <div class="sw-category-upselling-form__switches">
                        <mt-switch
                                v-model="upselling.active"
                                class="sw-category-detail-upselling__active-switch"
                                :label="$tc('sw-category.upselling.inputUpsellingActive')"
                                name="'upselling--active-'+upselling.id"
                        ></mt-switch>
                    </div>
                {% endblock %}

                {% block sw_category_upselling_form_product_stream_field_type %}
                    <mt-select
                            v-model="upselling.type"
                            :label="$tc('sw-category.upselling.inputUpsellingType')"
                            :options="upsellingTypes"
                            @update:model-value="onTypeChanged"
                    ></mt-select>
                {% endblock %}

                {% block sw_category_upselling_form_position_field %}
                    <mt-number-field
                        :name="'upselling--position-'+upselling.id"
                        numberType="int"
                        :min="1"
                        :label="$tc('sw-category.upselling.inputUpsellingPosition')"
                        :placeholder="$tc('sw-category.upselling.inputUpsellingPositionPlaceholder')"
                        v-model="upselling.position">
                    </mt-number-field>
                {% endblock %}
            </sw-container>

            <div v-if="!useManualAssignment">
                {% block sw_category_upselling_form_product_stream_field %}
                    <sw-entity-single-select
                        id="sw-field--upSelling-product-group"
                        v-model:value="upselling.productStreamId"
                        entity="product_stream"
                        class="sw-select-upselling__select-product-stream"
                        :label="$tc('sw-category.upselling.inputUpsellingProductStream')"
                        :placeholder="$tc('sw-category.upselling.inputUpsellingProductStreamPlaceholder')"
                        show-clearable-button>
                    </sw-entity-single-select>
                {% endblock %}

                <sw-container
                    columns="1fr 1fr"
                    gap="0px 30px">

                    {% block sw_category_upselling_form_sort_field %}
                        <mt-select
                                :model-value="sortingConCat"
                                :label="$tc('sw-category.upselling.inputUpsellingSorting')"
                                :options="sortingTypes"
                                @update:model-value="onSortingChanged"
                        ></mt-select>
                    {% endblock %}

                    {% block sw_category_upselling_form_limit_field %}
                        <mt-number-field
                            v-model="upselling.limit"
                            number-type="int"
                            :label="$tc('sw-category.upselling.inputUpsellingLimit')">
                        </mt-number-field>
                    {% endblock %}
                </sw-container>

                {% block sw_category_upselling_form_preview_link %}
                    <sw-container
                        columns="1fr"
                        justify="end"
                        class="sw-category-upselling-form__links"
                    >
                        <a
                            class="sw-card__quick-link"
                            :class="{ 'is--disabled': previewDisabled }"
                            @click="openModalPreview"
                        >
                            {{ $tc('sw-category.upselling.linkOpenStreamPreview') }}
                            <mt-icon
                                name="regular-long-arrow-right"
                                size="16px"
                            >
                            </mt-icon>
                        </a>
                    </sw-container>
                {% endblock %}
            </div>

            {% block sw_category_detail_upselling_assignment %}
                <sw-product-upselling-assignment
                    v-else
                    :upselling-assigned-products="upselling.upsellingAssignedProducts"
                    :upselling-id="upselling.id"
                    :searchable-fields="['name', 'productNumber']">
                </sw-product-upselling-assignment>
            {% endblock %}
        </sw-card>

        {% block sw_category_detail_upselling_form_modal_delete %}
            <sw-modal
                    v-if="showDeleteModal"
                    @modal-close="onCloseDeleteModal"
                    variant="small"
                    :title="$tc('sw-category.upselling.deleteConfirmTitle')"
                    class="sw-category-detail-upselling__delete-modal">
                {% block sw_category_detail_upselling_form_delete_text %}
                    <p>
                        {{ $tc('sw-category.upselling.deleteConfirmText') }}
                    </p>
                {% endblock %}

                {% block sw_category_detail_upselling_form_modal_delete_footer %}
                    <template #modal-footer>
                        {% block sw_category_detail_upselling_modal_delete_action_cancel %}
                            <mt-button
                                    size="small"
                                    variant="secondary"
                                    @click="onCloseDeleteModal">
                                {{ $tc('sw-category.upselling.deleteButtonCancel') }}
                            </mt-button>
                        {% endblock %}

                        {% block sw_category_detail_upselling_form_modal_delete_action_delete %}
                            <mt-button
                                class="sw-category-detail-upselling__delete-button"
                                size="small"
                                variant="critical"
                                @click="onConfirmDelete">
                                {{ $tc('sw-category.upselling.deleteButtonDelete') }}
                            </mt-button>
                        {% endblock %}
                    </template>
                {% endblock %}
            </sw-modal>
        {% endblock %}

        {% block sw_category_detail_upselling_modal_preview_modal %}
            <sw-product-stream-modal-preview
                v-if="showModalPreview"
                :filters="productStreamFilter"
                ref="modalPreview"
                @modal-close="closeModalPreview">
            </sw-product-stream-modal-preview>
        {% endblock %}
    </div>
{% endblock %}
